import { MarketNewsContentEntity, } from "@domains/entities/interfaces/iMarketNews";
import * as moment from "moment";
// import * as moment from "@frameworks/web/node_modules/moment/ts3.1-typings/moment";
export class MarketNewsDataMapper {
    mapTo(MarketNewsData) {
        let entity = new Array();
        MarketNewsData.map((item) => {
            let time = this.convertEPochToDate(item.pubDateEpoch);
            let marketNewsContent = new MarketNewsContentEntity(time, item.title, item.imageUrl, item.source);
            entity.push(marketNewsContent);
        });
        return entity;
    }
    convertEPochToDate(epoch) {
        return epoch != null && epoch != ""
            ? moment(new Date(parseInt(epoch) * 1000).toLocaleString()).fromNow()
            : "";
        // return "";
    }
}
